import React from 'react';

/**
* Renders a placeholder skeleton for the problem page layout while content loads.
* @example
* ProblemPageSkeleton()
* <div className="h-screen flex animate-pulse">…</div>
* @returns {JSX.Element} Skeleton markup representing the loading state.
**/
const ProblemPageSkeleton = () => {
  return (
    <div className="h-screen flex animate-pulse">
      {/* Left Panel - Description */}
      <div className="w-1/2 border-r border-border-primary bg-background-primary p-6 overflow-hidden">
        {/* Title */}
        <div className="h-8 bg-background-tertiary rounded w-3/4 mb-4" />
        
        {/* Tags */}
        <div className="flex gap-2 mb-6">
          <div className="h-6 bg-background-tertiary rounded w-20" />
          <div className="h-6 bg-background-tertiary rounded w-24" />
        </div>
        
        {/* Description */}
        <div className="space-y-3 mb-6">
          <div className="h-4 bg-background-tertiary rounded w-full" />
          <div className="h-4 bg-background-tertiary rounded w-5/6" />
          <div className="h-4 bg-background-tertiary rounded w-4/6" />
        </div>
        
        {/* Examples */}
        <div className="space-y-4">
          <div className="h-6 bg-background-tertiary rounded w-32 mb-2" />
          <div className="bg-background-secondary rounded p-4 space-y-2">
            <div className="h-4 bg-background-tertiary rounded w-full" />
            <div className="h-4 bg-background-tertiary rounded w-3/4" />
          </div>
        </div>
      </div>

      {/* Right Panel - Editor */}
      <div className="w-1/2 bg-background-secondary flex flex-col">
        {/* Editor Header */}
        <div className="h-12 bg-background-tertiary border-b border-border-primary flex items-center px-4 gap-4">
          <div className="h-6 bg-background-primary rounded w-32" />
          <div className="h-6 bg-background-primary rounded w-24" />
        </div>
        
        {/* Editor Content */}
        <div className="flex-1 p-4 space-y-2">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="h-5 bg-background-tertiary rounded" style={{ width: `${60 + i * 5}%` }} />
          ))}
        </div>
        
        {/* Bottom Buttons */}
        <div className="h-16 bg-background-tertiary border-t border-border-primary flex items-center justify-end px-4 gap-3">
          <div className="h-10 bg-background-primary rounded w-24" />
          <div className="h-10 bg-background-primary rounded w-24" />
        </div>
      </div>
    </div>
  );
};

export default ProblemPageSkeleton;
